module.exports = __webpack_public_path__ + "static/img/2012.fa48711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2012.jpg
// module id = 303
// module chunks = 0